export default __webpack_public_path__ + "static/media/t5.404d4d08.png";